import { z } from 'zod';
import { WaitingListAcceptFormat } from '../../../enums';

export const AcceptWaitingListValidatorSchema = z.object({
  // The fan-facing accept endpoint takes a null format to mean "server default".
  format: z.enum(WaitingListAcceptFormat).nullable(),
});

export type AcceptWaitingListValidator = z.infer<
  typeof AcceptWaitingListValidatorSchema
>;
